import { useState, useEffect } from "react";

const ProgressiveImg = ({ placeholderSrc, src, loading = "lazy", alt = "", ...props }) => {
  const [imgSrc, setImgSrc] = useState(placeholderSrc || src);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setImgSrc(src);
  }, [src]);

  const customClass =
    placeholderSrc && imgSrc === placeholderSrc ? "loading" : "loaded";

  return (
    <img
      src={imgSrc}
      alt={alt}
      loading={loading}
      className={`image ${customClass}`}
      {...props}
    />
  );
};

export default ProgressiveImg;
